module.exports = __webpack_public_path__ + "img/ic-star-outline.65cfb515.svg";